module.exports = __webpack_public_path__ + "assets/pickup-824b0a.svg";